import { Card, CardContent, CardHeader } from '@src/components/ui/card'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@src/components/ui/tooltip'
import { Info } from 'lucide-react'

export interface RiskProfileCardProps {
  title?: string
  /** Shown in an info tooltip next to the title. */
  description?: string
  /** When provided renders the Export CSV button; called on click. */
  onExport?: React.ReactNode
  children: React.ReactNode
  className?: string
}

const RiskProfileCard = ({
  title,
  description,
  onExport,
  children,
  className,
}: RiskProfileCardProps) => (
  <Card className={className}>
    <CardHeader className="flex flex-row items-center py-3 px-4 justify-between gap-4 pb-3">
      <div className="flex items-center gap-1.5 min-w-0">
        {title !== undefined && (
          <span className="text-base font-semibold leading-none truncate">{title}</span>
        )}
        {description !== undefined && (
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="size-3.5 shrink-0 text-muted-foreground cursor-help" />
              </TooltipTrigger>
              <TooltipContent side="right" className="max-w-64 text-xs">
                {description}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>

      {onExport && children && <div className="ml-auto">{onExport}</div>}
    </CardHeader>

    <CardContent className="pt-4">{children}</CardContent>
  </Card>
)

export { RiskProfileCard }
